import middleware from "../../middleware";
class ErrorPage extends React.Component {
  render() {
    const { msg, className = "", style } = this.props;
    return (
      <div style={{ height: "100%", ...style }} className={className}>
        <div
          style={{
            position: "absolute",
            top: "35%",
            left: "40%",
            textAlign: "center"
          }}
        >
          <img src="/cloudstore/images/e9/error.png" />
          <div style={{ textAlign: "center" }}>{msg}</div>
        </div>
      </div>
    );
  }
}

const Com = middleware(ErrorPage, "WeaErrorPage");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-error-page/index.js